import { render, staticRenderFns } from "./EditCourse.vue?vue&type=template&id=3ead8b2c&scoped=true&"
import script from "./EditCourse.vue?vue&type=script&lang=js&"
export * from "./EditCourse.vue?vue&type=script&lang=js&"
import style0 from "./EditCourse.vue?vue&type=style&index=0&id=3ead8b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ead8b2c",
  null
  
)

export default component.exports